export default __webpack_public_path__ + "static/1-b01e606b8454cadfc0c903887d5cc0f0.png";